<template>
  <div class="water">
    <img class="bg" src="@assets/images/water_bg.jpg" alt="" />
    <div class="top">
      <div
        class="item"
        @click="collect(item.id)"
        :style="item.style"
        v-for="(item, index) in list"
        :key="index"
      >
        {{ item.number }}
      </div>
    </div>
    <div @click="collect(0)">
      <img class="collect_btn" src="@assets/images/collect_btn.png" alt="" />
    </div>
  </div>
</template>
<script>
import { bonusList, bonusGrant } from "../../api/user";
export default {
  name: "water",
  data() {
    return {
      list: [],
      page: 1,
      limit: 6
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    collect(id) {
      console.log(id);
      let arr = [];
      this.list.forEach(element => {
        arr.push(element.id);
      });
      let data = {
        id: id ? id : arr
      };
      bonusGrant(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({ mes: res.msg });
          if (!id) this.list = [];
          this.getlist();
        })
        .catch(res => {
          console.log(res);
        });
    },
    getlist() {
      let that = this;
      let data = {
        page: this.page,
        limit: this.limit
      };
      bonusList(data)
        .then(res => {
          let list = res.data; //请求的数据列表
          let list1 = that.list; //当前的数据列表
          console.log(list);
          console.log(list1);
          if (list1.length) {
            list1.forEach(ele => {
              list.forEach(element => {
                console.log(ele.id == element.id);
                if (ele.id == element.id) {
                  element["style"] = ele.style;
                }
              });
            });
          }
          list.forEach(element => {
            if (!element.style) {
              let style = {
                top: Math.floor(Math.random() * 20 + 20) + "vw",
                left: Math.random() * 90 + "vw"
              };
              element["style"] = style;
            }
          });
          this.list = list;
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
@keyframes scaleDraw {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0.9);
  }
}
.water {
  .bg {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }
  .top {
    position: relative;
    width: 100%;
    height: 100vw;
    .item {
      position: absolute;
      width: 10vw;
      height: 10vw;
      border-radius: 50%;
      line-height: 10vw;
      text-align: center;
      background-image: url("../../assets/images/water_icon.png");
      background-size: 100% 100%;
      color: #0f8c00;
      font-weight: bold;
      font-size: 3.73vw;
      // background: rgba(0, 255, 0, 0.5);
      -webkit-animation: scaleDraw 2s ease-in-out infinite;
    }
  }
  .collect_btn {
    position: fixed;
    right: 0;
    bottom: 20vh;
    width: 20vw;
    height: auto;
  }
}
</style>
